import { Action } from '@/_core/fluxstore/types';
import { NotificationSettingsState } from '../types';
import { useNotificationSettingsStore } from '../useModule';

const { registerReducer } = useNotificationSettingsStore();

export class SetConnectedToSlack extends Action<NotificationSettingsState> {
    public static ACTION_TYPE = 'SetConnectedToSlack';
    public constructor(public isConnected: boolean) {
        super(SetConnectedToSlack.ACTION_TYPE);
    }
}

const reducer = (state: NotificationSettingsState, action: SetConnectedToSlack): void => {
    state.slackIsConnected = action.isConnected;
};

//@ts-ignore
registerReducer(SetConnectedToSlack.ACTION_TYPE, reducer);
